import { useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SttFullDialog, SttTabs } from '../../../sporttia/all';
import TeacherDetail from './TeacherDetail';
import TeacherClasses from './TeacherClasses';

type Props = {
    teacherId?: string | number | null;
    onClose?: () => void;
    title?: string;
};

export default function Teacher({
    teacherId: propTeacherId,
    onClose: propOnClose,
    title,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const { id: urlId } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const location = useLocation();

    // Use prop if provided, otherwise use URL param
    const teacherId =
        propTeacherId !== undefined ? propTeacherId : (urlId ?? null);
    const isUrlMode = propTeacherId === undefined && urlId !== undefined;

    // Determine initial tab from URL path
    const isClassesTab = location.pathname.endsWith('/classes');
    const initialTab = isClassesTab ? 1 : 0;

    const handleClose = () => {
        if (propOnClose) {
            propOnClose();
        } else if (isUrlMode) {
            navigate('/teachers');
        }
    };

    const handleTabChange = (tabIndex: number) => {
        if (isUrlMode && teacherId) {
            if (tabIndex === 1) {
                navigate(`/teachers/${teacherId}/classes`, { replace: true });
            } else {
                navigate(`/teachers/${teacherId}`, { replace: true });
            }
        }
    };

    const [teacherName, setTeacherName] = useState<string | undefined>(title);
    const [idTeacher, setIdTeacher] = useState<string | number | null>(
        teacherId,
    );

    // -----| Render |-----
    return (
        <SttFullDialog
            open={teacherId !== null && teacherId !== undefined}
            onClose={handleClose}
            title={teacherName}
            urlPath={teacherId ? `/teachers/${teacherId}` : undefined}
        >
            <SttTabs
                initialTab={initialTab}
                onTabChange={isUrlMode ? handleTabChange : undefined}
                tabs={[
                    {
                        caption: t('Detail'),
                        component: (
                            <TeacherDetail
                                idTeacher={teacherId}
                                onClose={handleClose}
                                onCreate={(name: string, id: number) => {
                                    setTeacherName(name);
                                    setIdTeacher(id);
                                }}
                            />
                        ),
                    },
                    {
                        caption: t('Classes'),
                        component: (
                            <TeacherClasses
                                idTeacher={
                                    idTeacher !== 'create' ? idTeacher : null
                                }
                            />
                        ),
                    },
                ]}
            />
        </SttFullDialog>
    );
}
